import { getFormComponents } from './formComponent';
export default function (editor, opts = {}) {
  const { pfx, projectId, collections, version, isSearchHistoryPluginInstalled } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType('search-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': 'Data Search Form',
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          icon: '<i class="wb webconnect-search"></i>',
          isDrop: false,
          projectId: projectId,
          traits: [
            {
              type: 'select',
              label: 'Data Source',
              name: 'data-datasource',
              default: 'DEFAULT',
              options: [
                { value: 'DEFAULT', name: 'Default' },
                { value: 'SUPABASE', name: 'Supabase' },
                { value: 'DIRECTUS', name: 'Directus' },
              ],
            },
            {
              type: 'checkbox',
              label: 'Enable Auto Search',
              name: 'data-enableAutoSearch',
              default: false,
            },
            {
              type: 'checkbox',
              label: 'Enable Download All Records',
              name: 'data-downloadAllRecords',
              default: false,
            },
            ...(isSearchHistoryPluginInstalled
              ? [
                  {
                    type: 'checkbox',
                    label: 'Enable Search History',
                    name: 'data-enableSearchHistory',
                  },
                ]
              : []),
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
        },
        init() {
          if (!this.get('isDrop')) {
            const collectionName = this.findCollectionNameFromDataTable();
            this.set('collectionName', collectionName);
            this.handleCollectionChange();
            const calendar = this.closestType('calendar');
            if (calendar) {
              this.removeTrait('data-downloadAllRecords');
            }
            this.handleDataSource();
            this.set('isDrop', true);
          }
          this.on('change:collectionName', this.handleCollectionChange);
        },
        findCollectionNameFromDataTable() {
          const dataTable = this.closestType('data-table');
          const dataGroup = this.closestType('data-group');
          const calendar = this.closestType('calendar');
          let collectionName = this.get('collectionName');
          if (dataTable) {
            collectionName = dataTable.get('collectionName');
          } else if (dataGroup) {
            collectionName = dataGroup.get('collectionName');
          } else if (calendar) {
            collectionName = calendar.get('collectionName');
          }
          return collectionName;
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const calendar = this.closestType('calendar');
          if (collectionName) {
            this.addAttributes({
              'data-form-collection': collectionName,
            });
            const formElements = await getFormComponents(collectionName, collections);
            let form = `
              ${formElements}
                  <div style="flex-grow: 0.96;justify-content: flex-end;display: inline-flex;">
                    <button type="submit" class="btn btn-sm btn-primary mb-2 mr-0">Search</button>
                    ${
                      !calendar
                        ? `<button type="submit" class="btn btn-sm btn-success mb-2 mr-0" value="export">Download CSV</button>`
                        : ''
                    }
                  </div>
              </div>`;
            this.components(form);
          }
        },
        handleDataSource() {
          let collectionName = this.get('collectionName');
          if (collectionName && collections) {
            const selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
            if (selectedCollection) {
              const { sourceOfOrigin } = selectedCollection;
              if (sourceOfOrigin) {
                this.set('data-datasource', sourceOfOrigin);
                const attrs = this.getAttributes();
                attrs['data-datasource'] = sourceOfOrigin;
                this.setAttributes(attrs);
              }
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'search-form') {
            return {
              type: 'search-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
    }),
  });
}
